export default function (value) {
  if (typeof value !== "number" || isNaN(value)) {
    return value;
  }

  var exponent;
  var unit;
  var neg = value < 0;
  var units = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  if (neg) {
    value = -value;
  }

  if (value < 1) {
    return (neg ? "-" : "") + value + " B";
  }
  exponent = Math.min(Math.floor(Math.log(value) / Math.log(1000)), units.length - 1);
  value = (value / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];
  return (neg ? "-" : "") + value + " " + unit;
}
